import { Trans } from '@lingui/macro';
import { useMemo } from 'react';
import { get } from 'lodash';
import FormSection from '../../../form/FormSection';
import { SUB_TYPE_NAMES, VCENTER_TYPE } from '../../../filters/virtual-infrastructure-type-filter/SubTypeHelper';
import VirtualCommonFields from './VirtualCommonFields';
import VcenterFields from './VcenterFields';
import { useVirtualInfraContext } from '../InfrastructureUtils';

/**
 * Displays detail section for virtual infrastructure entities
 * Shows appropriate fields based on entity type
 */
const VirtualDetailSection = () => {
    const context = useVirtualInfraContext();

    const title = useMemo(() => {
        const typeName = get(SUB_TYPE_NAMES, context.subType, SUB_TYPE_NAMES[VCENTER_TYPE]);
        return <Trans>{typeName} Detail</Trans>;
    }, [context.subType]);

    const showCommonFields = context.isVirtualMachine || context.isHypervisor;
    const showVcenterFields = context.isVCenter || context.isCreateAction;

    return (
        <FormSection title={title}>
            {showCommonFields && <VirtualCommonFields />}
            {showVcenterFields && <VcenterFields />}
        </FormSection>
    );
};

export default VirtualDetailSection;
